import React, { createContext, useContext, useState } from 'react';

const ExchangeRateContext = createContext();

export const ExchangeRateProvider = ({ children }) => {
  const [exchangeRate, setExchangeRate] = useState(() => {
    const saved = localStorage.getItem('exchangeRate');
    return saved ? parseFloat(saved) : 1.23;
  });

  const updateRate = (rate) => {
    setExchangeRate(rate);
    localStorage.setItem('exchangeRate', rate);
  };

  return (
    <ExchangeRateContext.Provider value={{ exchangeRate, setExchangeRate: updateRate }}>
      {children}
    </ExchangeRateContext.Provider>
  );
};

export const useExchangeRate = () => useContext(ExchangeRateContext);
